module.exports = __webpack_public_path__ + "img/addIcon.80d939c4.png";